/*
  钉钉调用API封装
*/
import * as dd from 'dingtalk-jsapi'
import {
  IS_DING,
  isWebPlatform,
  getTitle,
  IS_ANDROID,
  timeFormat
} from '@/utils/comUtils'
import vm from '@/main'
import {
  dingJsAuthConfig,
  dingRequestAuthCode,
  dingDisableWebViewBounce,
  dingSetTitle,
  dingClosePage,
  dingSetRight,
  dingSetMenu,
  dingScan,
  dingOpenLink,
  dingNavigateToPage,
  dingRequestAuthInfo,
  dingCreateMessage,
  dingSetLeft,
  dingShare
} from '@/utils/dingSdkUtils'
// import { h5Host } from '@/env'

export async function mcJsAuthConfig(config) {
  const _config = !isWebPlatform() && (await dingJsAuthConfig(config))
  return _config
}
export async function mcRequestAuthCode(corpId) {
  const _config = !isWebPlatform() && (await dingRequestAuthCode(corpId))
  return _config
}

// loading 专用
let $toast = null
// menu专用
let menuAction = null

export function mcOpenLink({ url }) {
  if (IS_DING) {
    dingOpenLink({ url })
      .then(res => {})
      .catch(err => {
        console.log(err)
      })
  } else {
    window.open(url, '_blank')
  }
}
export function mcNavigateToPage({ url }) {
  if (IS_DING) {
    dingNavigateToPage({ url })
      .then(res => {})
      .catch(err => {
        console.log(err)
      })
  } else {
    window.open(url, '_blank')
  }
}

const _currentDate = new Date()
export function mcDatePicker({
  date,
  format = 'YYYY/MM/DD',
  minDate = new Date(
    _currentDate.getFullYear() - 1,
    _currentDate.getMonth(),
    _currentDate.getDate()
  ),
  maxDate = new Date(
    _currentDate.getFullYear() + 1,
    _currentDate.getMonth(),
    _currentDate.getDate()
  )
} = {}) {
  let params = {}
  minDate && (params.minDate = minDate)
  maxDate && (params.maxDate = maxDate)

  return new Promise((resolve, reject) => {
    const picker = vm.$DateTimePicker({
      $props: {
        type: 'date',
        defaultValue: date,
        ...params
      },
      $events: {
        confirm(time) {
          let dateStr = timeFormat(time, format)
          // 无法复现 http://192.168.7.225/pro/bug-view-62227.html 此bug 做下保护
          // 如果存在最大最小日期的限制 返回的日期还不在范围内 就取上一次的时间
          if (minDate && maxDate && (time > maxDate || time < minDate)) {
            dateStr = timeFormat(new Date(date.replace(/-/gi, '/')), format)
          }
          resolve({
            date: dateStr,
            picker
          })
        }
      }
    })
    picker.show()
  })
}

export function mcMonthPicker({
  date,
  minDate = new Date(
    _currentDate.getFullYear() - 1,
    _currentDate.getMonth(),
    _currentDate.getDate()
  ),
  maxDate = new Date(
    _currentDate.getFullYear() + 1,
    _currentDate.getMonth(),
    _currentDate.getDate()
  )
} = {}) {
  let params = {}
  minDate && (params.minDate = minDate)
  maxDate && (params.maxDate = maxDate)

  return new Promise((resolve, reject) => {
    const picker = vm.$DateTimePicker({
      $props: {
        type: 'year-month',
        defaultValue: date,
        ...params
      },
      $events: {
        confirm(time) {
          resolve({
            date: time,
            picker
          })
        }
      }
    })
    picker.show()
  })
}

export function mcModel({
  image = '', // 无用
  buttonName = ['我知道了'],
  title = '',
  content = '',
  banner = []
} = {}) {
  return new Promise((resolve, reject) => {
    vm.$Dialog(
      {
        title: title,
        content: content,
        confirmBtn: {
          color: '#006afe',
          text: buttonName[0]
        },
        $events: {
          confirm() {
            resolve()
          }
        }
      },
      createElement => {
        return [
          createElement('img', {
            attrs: {
              src: banner[0],
              width: '100%'
            },
            slot: 'icon'
          })
        ]
      }
    ).show()
  })
}

export function mcSetTitle(title = getTitle()) {
  if (IS_DING) {
    dingSetTitle(title)
  } else {
    window.document.title = title
  }
}

export async function mcSetRight({
  show = true,
  control = false,
  text = '',
  handle = () => {}
} = {}) {
  if (!isWebPlatform()) {
    const _dingSetRight = await dingSetRight({ show, control, text, handle })
    return _dingSetRight
  }
}

export async function mcRequestAuthInfo(code) {
  if (IS_DING) {
    const _dingRequestAuthInfo = await dingRequestAuthInfo(code)
    return _dingRequestAuthInfo
  }
}

export async function mcDingSetLeft(params) {
  if (IS_DING) {
    const _dingSetLeft = await dingSetLeft(params)
    return _dingSetLeft
  }
}

export async function mcCreateMessage(params) {
  if (!isWebPlatform()) {
    const _dingCreateMessage = await dingCreateMessage(params)
    return _dingCreateMessage
  }
}

export async function mcSetMenu({
  backgroundColor = '#FFFFFF',
  items = []
} = {}) {
  // items : [{
  //     id: 1,
  //     iconId: '',
  //     text: '帮助',
  //     url: 'http://img.alicdn.com/tps/TB1XLjqNVXXXXc4XVXXXXXXXXXX-170-64.png'
  // }],
  return new Promise(async (resolve, reject) => {
    if (isWebPlatform()) {
      menuAction = vm.$ActionSheet({
        title: '请选择',
        cancelText: '取消',
        actions: items,
        onChoose(item, index) {
          resolve(item)
        }
      })
    } else {
      try {
        const _dingSetMenu = await dingSetMenu({
          backgroundColor,
          items
        })
        resolve(_dingSetMenu)
      } catch (e) {
        reject(e)
      }
    }
  })
}

export function showMcMenu() {
  const _actions = (menuAction || {}).actions
  const _menuLen = (_actions || []).length
  if (_menuLen === 1) {
    menuAction.handlerToChoose(_actions[0], 0)
  } else if (_menuLen > 1) {
    menuAction.show()
  }
}

export function mcClosePage() {
  if (IS_DING) {
    dingClosePage()
  }
}

export function mcGoBack(step = -1) {
  window.history.go(step)
}
export function mcShowPreloader({ text = '加载中' } = {}) {
  $toast = vm.$Toast({
    content: text,
    type: 'loading'
  })
  $toast && $toast.show()
}

export function mcHidePreloader() {
  return new Promise(resolve => {
    $toast && $toast.hide()
    resolve()
  })
}

export function mcToast({
  msg,
  duration,
  delay = 0,
  icon = '',
  type = 'text'
} = {}) {
  vm.$Toast({
    content: msg,
    duration: duration || 2000,
    type,
    // icon,
    closeOnPopstate: false
  }).show()
}

export function mcAlert({ msg, buttonName = '知道了', title = '提示' } = {}) {
  return new Promise((resolve, reject) => {
    vm.$Dialog({
      title: title,
      content: msg,
      confirmBtn: {
        color: '#006afe',
        text: buttonName
      },
      onConfirm() {
        resolve()
      }
    }).show()
  })
}

export function mcConfirm({
  msg = '',
  buttonName = ['取消', '确认'],
  title = '提示',
  closeOnPopstate = true,
  cancelButtonColor = '#171a1d',
  confirmButtonColor = '#006afe'
} = {}) {
  return new Promise((resolve, reject) => {
    vm.$Dialog({
      type: 'confirm',
      title: title,
      content: msg,
      cancelBtn: {
        color: cancelButtonColor,
        text: buttonName[0]
      },
      confirmBtn: {
        color: confirmButtonColor,
        text: buttonName[1]
      },
      closeOnPopstate,
      onCancel() {
        resolve(0)
      },
      onConfirm() {
        resolve(1)
      }
    }).show()
  })
}

export function mcScan({ type = 'qrCode' }) {
  return new Promise((resolve, reject) => {
    dingScan({
      type // type为qrCode或者barCode
    })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 禁用iOS webview弹性效果
export function disableWebViewBounce() {
  if (IS_DING) {
    return dingDisableWebViewBounce()
  }
  return new Promise((resolve, reject) => {
    if (IS_ANDROID) return resolve()
    try {
      document.querySelector('body').classList.add('hidden')
      document.querySelector(
        '#app'
      ).style.cssText = `overflow-y:auto;-webkit-overflow-scrolling:touch;`
      resolve()
    } catch (e) {
      reject(e)
    }
  })
}

// 选择人和部门
export function dingComplexPicker({
  title = '请选择人员',
  corpId,
  multiple = false,
  maxUsers = 1500,
  pickedUsers = [],
  pickedDepartments = [],
  disabledUsers = [],
  disabledDepartments = [],
  requiredUsers = [],
  requiredDepartments = [],
  appId = '',
  responseUserOnly = true
} = {}) {
  return new Promise((resolve, reject) => {
    dd.biz.contact.complexPicker({
      title: title, // 如果你需要修改选人页面的title，可以在这里赋值
      corpId: corpId, // 企业id
      multiple: multiple, // 是否多选： true多选 false单选； 默认true
      limitTips: '最多可选择' + maxUsers + '人', // 超过人数限制的提示语可以用这个字段自定义
      maxUsers: maxUsers, // 人数限制，当multiple为true才生效，可选范围1-1500
      pickedUsers: pickedUsers, // 已选用户
      pickedDepartments: pickedDepartments, // 已选部门
      disabledUsers: disabledUsers, // 不可选用户
      disabledDepartments: disabledDepartments, // 不可选部门
      requiredUsers: requiredUsers, // 必选用户（不可取消选中状态）
      requiredDepartments: requiredDepartments, // 必选部门（不可取消选中状态）
      appId: appId, // 微应用的Id
      permissionType: 'GLOBAL', // 选人权限，目前只有GLOBAL这个参数
      responseUserOnly: responseUserOnly, // 返回人，或者返回人和部门
      onSuccess(data) {
        resolve(data)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 开始录音
export function dingAudioStartRecord(maxDuration = 60) {
  return new Promise((resolve, reject) => {
    dd.device.audio.startRecord({
      maxDuration: maxDuration,
      onSuccess() {
        resolve()
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 停止录音
export function dingAudioStopRecord() {
  return new Promise((resolve, reject) => {
    dd.device.audio.stopRecord({
      onSuccess(res) {
        resolve(res)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 监听录音自动停止
export function dingAudioEnd() {
  return new Promise((resolve, reject) => {
    dd.device.audio.onRecordEnd({
      onSuccess(res) {
        resolve(res)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

// 语音转文字
export function dingAudioTranslateVoice(mediaId, duration) {
  return new Promise((resolve, reject) => {
    dd.device.audio.translateVoice({
      mediaId: mediaId,
      duration: duration,
      onSuccess(res) {
        resolve(res)
      },
      onFail(e) {
        reject(e)
      }
    })
  })
}

export function mcDateTimePicker({
  defaultValue,
  minDate = new Date(),
  maxDate = new Date(
    _currentDate.getFullYear() + 1,
    _currentDate.getMonth(),
    _currentDate.getDate()
  )
} = {}) {
  let params = {}
  minDate && (params.minDate = minDate)
  maxDate && (params.maxDate = maxDate)

  return new Promise((resolve, reject) => {
    const picker = vm.$DateTimePicker({
      $props: {
        type: 'date-time',
        defaultValue,
        ...params
      },
      $events: {
        confirm(time) {
          resolve({
            time,
            picker
          })
        }
      }
    })
    picker.show()
  })
}

export const mcHalfDayPicker = ({
  defaultValue,
  minDate,
  maxDate = new Date(
    _currentDate.getFullYear() + 1,
    _currentDate.getMonth(),
    _currentDate.getDate()
  )
} = {}) => {
  let params = {}
  minDate && (params.minDate = minDate)
  maxDate && (params.maxDate = maxDate)
  return new Promise((resolve, reject) => {
    const picker = vm.$DateTimePicker({
      $props: {
        type: 'half-day',
        defaultValue,
        ...params
      },
      $events: {
        confirm(time) {
          resolve({
            time,
            picker
          })
        }
      }
    })
    picker.show()
  })
}

export function mcTimePicker({
  defaultValue,
  minTime = '00:00',
  maxTime = '23:59',
  crossDay = false,
  maskHide = false
} = {}) {
  return new Promise((resolve, reject) => {
    const picker = vm.$DateTimePicker({
      $props: {
        type: 'time',
        defaultValue,
        minTime,
        maxTime,
        crossDay,
        maskHide
      },
      $events: {
        confirm(time) {
          resolve(time)
        }
      }
    })
    picker.show()
  })
}
export async function mcShare(params) {
  let res = null
  if (IS_DING) {
    res = await dingShare(params)
  }
  return res
}
